import React from 'react';
import { CallNow } from '../../../CallNow';

interface Props {
  whatsapp?: string;
  phone?: string;
  companyName?: string;
  name?: string;
  dataValue?: string;
  contacts?: { infoContact: string }[];
  description?: string;
}

export const ShopContactTablet = ({ whatsapp, phone, name, dataValue, contacts }: Props) => {
  return (
    <section>
      <h2 className="f20 abbey fw2 lh-copy ma0 mb12 mt24">Contato</h2>
      <div className="flex flex-column">
        {
          // tslint:disable-next-line: jsx-no-multiline-js
          whatsapp && (
            <CallNow
              adId={0}
              type="small"
              name={name}
              hasToCall={false}
              numberPhone={whatsapp}
              dataValue={dataValue}
            />
          )
        }
        {whatsapp && phone && <div className="mt4" />}
        {
          // tslint:disable-next-line: jsx-no-multiline-js
          phone && (
            <CallNow
              adId={0}
              type="small"
              name={name}
              hasToCall
              numberPhone={phone}
              dataValue={dataValue}
              contacts={contacts}
            />
          )
        }
      </div>
    </section>
  );
};
